// The user bubble's classes, shared with the pending conversation and the
// Learn Phoebe fake chat so every bubble reads the same.
export const USER_MESSAGE_BUBBLE_CLASSES =
    'bg-muted w-max max-w-[min(100%,34rem)] rounded-lg ' +
    'px-4 py-2.5 text-v3-chat ' +
    'break-words whitespace-pre-wrap';
